export const siteConfig = {
  name: "پلیس پلاس",
  shortName: "پلیس پلاس",
  title: "پنل دفاتر پلیس ۱۰+؛ عوارض سالیانه و سمیع | پلیس پلاس",
  description:
    "پلیس پلاس، پنل خدمات خودرو برای دفاتر پلیس ۱۰+؛ آشنایی با عوارض سالیانه خودرو (سمیع)، مالیات نقل و انتقال و شرایط دسترسی و شروع همکاری دفتر.",
  locale: "fa-IR",
  language: "fa",
  direction: "rtl" as const,
  siteUrl: import.meta.env.VITE_SITE_URL || "http://localhost:5173",
  apiUrl: import.meta.env.VITE_API_URL || "http://localhost:3000",
  apiMode: import.meta.env.VITE_API_MODE || "mock",
  defaultTheme: "stripe",
  socialImage: "/images/social-card.svg",
} as const;
